// How to use animation controller
// Animation Group is a collection of animations
// Animation is a collection of 1 or more animators
//
// Create an animation group
// Create an animation and add it to the group. An animation works on one actor, must be a libs object
// Create animators to the animation. Animators apply to that actor only
// Start animation. Callbacks occur for each animation, then once all animations are complete, one for the animaton group.

// This example creates an animation that moves a sprite right by 500 pixels over 5 seconds, starting after 1 second
//      var animationGroup = animationController.animationGroup();
//      var animation = animationController.animation(mySprite);
//      animation.add(animationController.animations.moveBy({x:500,y:0}, 5, animationController.interpolators.easeOutSine), 1);
//      animationGroup.add(animation);
//      animationController.play(animationGroup, myOnnCompleteFunction)

animationController = {};

(function(){

    var currentlyAnimating = [];

    animationController.create = function() {
        var instance = {};
        
        instance.initialise = function() {
            Reflex.addToUpdate(animationController.update);
        }

        return instance;
    };

    animationController.update = function(delta){
        var j;
        for (var i = currentlyAnimating.length - 1; i >= 0; i--){
            var animationGroup = currentlyAnimating[i];
            var animationGroupComplete = true;

            var animations = animationGroup.getAnimations();
            for (var j = 0; j < animations.length; j++) {
                var animation = animations[j];
                var animators = animation.getAnimators();
                var updatedData = JSON.parse(JSON.stringify(animation.initialData));

                // Apply all animators
                var allFinished = true;
                for (var k = 0; k < animators.length; k++){
                    var obj = animators[k];
                    if (obj.startDelay > 0) {
                        obj.startDelay -= delta;
                        allFinished = false;
                    }
                    else {
                        var who = animation.getActor();
                        obj.animationTimer.runningTime += delta;
                        obj.update(updatedData);
                        animationController.updateActor(who, updatedData);
                        allFinished = allFinished && obj.animationTimer.hasFinished();
                    }
                }

                // Have all animators finished?
                if (allFinished) {
                    animators = [];
                    if (checkForDefined(animation.callback)) {
                        animation.callback();
                    }
                }
                else {
                    // Still animating
                    animationGroupComplete = false;

                }
            }
            if (animationGroupComplete) {
                animationController.stop(animationGroup);
            }
        }
    }

    animationController.updateActor = function(actor, data) {
        actor.position.set(data.x, data.y);
        actor.scale.set(data.scaleX, data.scaleY);
        actor.rotation = data.rotation;
        actor.alpha = data.alpha;
        actor.visible = data.visible;
    };

    // Kick off the animation / animationGroup
    animationController.play = function(animationGroup, allAnimationsCompleteCallback, data){
        if (!animationGroup.isAnimationGroup()) {
            // This is a single animation, so add to an animation group (for backwards compatibility)
            var newAnimationGroup = animationController.animationGroup();
            newAnimationGroup.add(animationGroup);
            newAnimationGroup.callback = animationGroup.callback;
            animationGroup = newAnimationGroup;
        }

        // Add animation group calllback
        animationGroup.callback = allAnimationsCompleteCallback;
        animationGroup.data = data;

        var animations = animationGroup.getAnimations();

        for (var i = 0; i < animations.length; i++) {
            var animation = animations[i];
            var who = animation.getActor();
            if (currentlyAnimating[who.Props.FQN] !== undefined){
                this.stop(who);
            }

            animation.initialData = {
                x: who.position.x,
                y: who.position.y,
                rotation: who.rotation,
                scaleX: who.scale.x,
                scaleY: who.scale.y,
                alpha: who.alpha,
                visible: who.visible
            };
        }

        currentlyAnimating.push(animationGroup);
    }

    animationController.stop = function(animationGroup){
        if (currentlyAnimating.indexOf(animationGroup) === -1) {
            console.log("Cannot find animation group");
            return;
        }

        // As stop can be called externally, we need to make sure all animations are at the end
        var animations = animationGroup.getAnimations();
        
        for (var i = 0; i < animations.length; i++) {
            var animation = animations[i];
            var finalData = JSON.parse(JSON.stringify(animation.initialData));
            var animators = animation.getAnimators();
            for (var j = 0; j < animators.length; j++) {
                var animator = animators[j];
                animator.animationTimer.endTimer();
                animator.update(finalData);
                animationController.updateActor(animation.getActor(), finalData);
            }
        }

        currentlyAnimating.splice(currentlyAnimating.indexOf(animationGroup), 1);

        if (checkForDefined(animationGroup.callback)) {
            animationGroup.callback(animationGroup.data);
        }
    };

    animationController.animationGroup = function() {
        var animations = [];

        return {
            isAnimationGroup: function() { return true; },
            add: function(animation) {
                animation.animationGroup = this;
                animations.push(animation);
            },
            getAnimations: function() {
                return animations;
            },
            removeAnimation: function(index) {
                animations.splice(index, 1);
            }
        }
    }

    // An animation contains 1 or more animators, and has one actor
    // Once all animators in an animation have completed, the callback will fire for that animator
    animationController.animation = function(who, animatorCompleteCallback) {
        var chains = [];
        var animators = [];

        return {
            isAnimationGroup: function() { return false; },
            getActor: function(){
                return who;
            },
            chain: function(animation){
                chains.push(animation);
            },
            add: function( animator, startDelay ){
                animator.init(who);
                animator.startDelay = checkForDefined(startDelay) ? (startDelay * 1000) : 0;
                animators.push(animator);
            },
            addEvent: function( callback ) {
                var animator = animationController.animations.event( callback );
                animator.startDelay = checkForDefined(startDelay) ? (startDelay * 1000) : 0;
                animators.push(animator);
            },
            invokeCallback: function(){
                if (this.callback)
                    this.callback();
            },
            getAnimators: function(){
                if (animators.length === 0){
                    if (chains.length === 0){
                        return undefined;
                    }
                    animators = chains[0].getAnimators();
                    chains.splice(0,1);
                }
                return animators;
            },
            callback: animatorCompleteCallback
        }
    }

    var animatorTimer = function(duration){
        return {
            runningTime: 0,
            hasFinished: function() { return this.runningTime >= (1000*duration) },
            getProgress: function() { return Math.min(this.runningTime/(1000*duration), 1.0); },
            endTimer: function() { this.runningTime = 1000*duration; }
            }
    }

    // A single animator that can chance position, rotation, scale, alpha or visibility
    // The data object passed in should be updated with the new parameter
    animationController.animations = {
        moveBy: function(deltaPos, duration, interpolator){
            return {
                animationTimer: animatorTimer(duration),
                init: function(who){
                },
                update: function(data){
                    data.x = interpolator(this.animationTimer.getProgress(), data.x, deltaPos.x, 1.0);
                    data.y = interpolator(this.animationTimer.getProgress(), data.y, deltaPos.y, 1.0);
                }
            }
        },
        moveTo: function(targetPos, duration, interpolator){
            return {
                animationTimer: animatorTimer(duration),
                init: function(who){

                },                              
                update: function(data){
                    data.x = interpolator(this.animationTimer.getProgress(), data.x, targetPos.x - data.x, 1.0);
                    data.y = interpolator(this.animationTimer.getProgress(), data.y, targetPos.y - data.y, 1.0);
                }
            }
        },
        moveFromTo: function(startPos, targetPos, duration, interpolator){
            return {
                animationTimer: animatorTimer(duration),
                init: function(who){ },                              
                update: function(data){
                    data.x = interpolator(this.animationTimer.getProgress(), startPos.x, targetPos.x - startPos.x, 1.0);
                    data.y = interpolator(this.animationTimer.getProgress(), startPos.y, targetPos.y - startPos.y, 1.0);
                }
            }
        },
        scaleBy: function(deltaScale, duration, interpolator){
            return {
                animationTimer: animatorTimer(duration),
                init: function(who){
                },
                update: function(data){
                    data.scaleX = interpolator(this.animationTimer.getProgress(), data.scaleX, deltaScale.x, 1.0);
                    data.scaleY = interpolator(this.animationTimer.getProgress(), data.scaleY, deltaScale.y, 1.0);
                }
            }
        },
        scaleTo: function(targetScale, duration, interpolator){
            return {
                animationTimer: animatorTimer(duration),
                init: function(who){
                },
                update: function(data){
                    data.scaleX = interpolator(this.animationTimer.getProgress(), data.scaleX, targetScale.x - data.scaleX, 1.0);
                    data.scaleY = interpolator(this.animationTimer.getProgress(), data.scaleY, targetScale.y - data.scaleY, 1.0);
                }
            }
        },
        scaleFromTo: function(startScale, targetScale, duration, interpolator){
            return {
                animationTimer: animatorTimer(duration),
                init: function(who){},
                update: function(data){
                    data.scaleX = interpolator(this.animationTimer.getProgress(), startScale.x, targetScale.x - startScale.x, 1.0);
                    data.scaleY = interpolator(this.animationTimer.getProgress(), startScale.y, targetScale.y - startScale.y, 1.0);
                }
            }
        },
        alphaBy: function(newAlpha, duration, interpolator){
            return {
                 init: function(who){
                },
                animationTimer: animatorTimer(duration),
                update: function(data){
                    data.alpha = interpolator(this.animationTimer.getProgress(), data.alpha, newAlpha, 1.0);
                }
            }
        },
        alphaTo: function(deltaAlpha, duration, interpolator){
            return {
                 init: function(who){
                },
                animationTimer: animatorTimer(duration),
                update: function(data){
                    data.alpha = interpolator(this.animationTimer.getProgress(), data.alpha, deltaAlpha-data.alpha, 1.0);
                }
            }
        },
        alphaFromTo: function(startAlpha, endAlpha, duration, interpolator){
            return {
                init: function(who){},
                animationTimer: animatorTimer(duration),
                update: function(data){
                    data.alpha = interpolator(this.animationTimer.getProgress(), startAlpha, endAlpha-startAlpha, 1.0);
                }
            }
        },
        rotateBy: function(deltaRotation, duration, interpolator){
            return {
                 init: function(who){
                },
                animationTimer: animatorTimer(duration),
                update: function(data){
                    data.rotation = interpolator(this.animationTimer.getProgress(), data.rotation, deltaRotation, 1.0);
                }
            }
        },
        rotateTo: function(targetRotation, duration, interpolator){
            return {
                 init: function(who){
                },
                animationTimer: animatorTimer(duration),
                update: function(data){
                    data.rotation = interpolator(this.animationTimer.getProgress(), data.rotation, targetRotation - data.rotation, 1.0);
                }
            }
        },
        rotateFromTo: function(startRotation, targetRotation, duration, interpolator){
            return {
                init: function(who){},
                animationTimer: animatorTimer(duration),
                update: function(data){
                    data.rotation = interpolator(this.animationTimer.getProgress(), startRotation, targetRotation - startRotation, 1.0);
                }
            }
        },
        delay: function(duration){
            return {
                init: function(who){},
                animationTimer: animatorTimer(duration),
                update: function(data){
                }
            }
        },
        show: function(){
            return {
                init: function(who){},
                animationTimer: animatorTimer(0),
                update: function(data){
                    data.visible = true;
                }
            }
        },
        hide: function(){
            return {
                init: function(who){},
                animationTimer: animatorTimer(0),
                update: function(data){
                    data.visible = false;
                }
            }
        },
        bounce: function(deltaPos, duration, interpolator) {
            return {
                animationTimer: animatorTimer(duration),
                init: function(who){
                },
                update: function(data){
                    var sProg = Math.sin(Math.PI * this.animationTimer.getProgress());
                    data.x = interpolator(sProg, data.x, deltaPos.x, 1.0);
                    data.y = interpolator(sProg, data.y, deltaPos.y, 1.0);
                }
            }
        },
        event: function(callback, data){
            return {
                callback: callback,
                data: data,
                triggered: false,
                init: function(who, callback){},
                animationTimer: animatorTimer(0),
                update: function(){
                    if (!this.triggered && this.animationTimer.hasFinished()) {
                        this.triggered = true;
                        this.callback(this.data);
                    }

                }
            }
        }
    }

    // see http://gizma.com/easing/
    animationController.interpolators = {
        linearTween: function(t, b, c, d){
            return c*t/d + b;
        },
        easeInQuad: function(t, b, c, d){
            t /= d;
	        return c*t*t + b;
        },
        easeOutQuad: function(t, b, c, d){
            t /= d;
	        return -c * t*(t-2) + b;
        },
        easeInOutQuad: function(t, b, c, d){
            t /= d/2;
            if (t < 1) return c/2*t*t + b;
            t--;
            return -c/2 * (t*(t-2) - 1) + b;
        },
        easeInCubic: function(t, b, c, d){
            t /= d;
	        return c*t*t*t + b;
        },
        easeOutCubic: function(t, b, c, d){
            t /= d;
            t--;
            return c*(t*t*t + 1) + b;
        },
        easeInOutCubic: function(t, b, c, d){
            t /= d/2;
            if (t < 1) return c/2*t*t*t + b;
            t -= 2;
            return c/2*(t*t*t + 2) + b;
        },
        easeInQuart: function(t, b, c, d){
            t /= d;
	        return c*t*t*t*t + b;
        },
        easeOutQuart: function(t, b, c, d){
            t /= d;
            t--;
            return -c * (t*t*t*t - 1) + b;
        },
        easeInOutQuart: function(t, b, c, d){
            t /= d/2;
            if (t < 1) return c/2*t*t*t*t + b;
            t -= 2;
            return -c/2 * (t*t*t*t - 2) + b;
        },
        easeInQuint: function(t, b, c, d){
            t /= d;
	        return c*t*t*t*t*t + b;
        },
        easeOutQuint: function(t, b, c, d){
            t /= d;
            t--;
            return c*(t*t*t*t*t + 1) + b;
        },
        easeOutQuint: function(t, b, c, d){            
            t /= d/2;
            if (t < 1) return c/2*t*t*t*t*t + b;
            t -= 2;
            return c/2*(t*t*t*t*t + 2) + b;
        },
        easeInSine: function(t, b, c, d){
            return -c * Math.cos(t/d * (Math.PI/2)) + c + b;
        },
        easeOutSine: function(t, b, c, d){
            return c * Math.sin(t/d * (Math.PI/2)) + b;
        },
        easeInOutSine: function(t, b, c, d){
            return -c/2 * (Math.cos(Math.PI*t/d) - 1) + b;
        },
        easeInExpo: function(t, b, c, d){
            return c * Math.pow( 2, 10 * (t/d - 1) ) + b;
        },
        easeOutExpo: function(t, b, c, d){
            return c * ( -Math.pow( 2, -10 * t/d ) + 1 ) + b;
        },
        easeInOutExpo: function(t, b, c, d){
            t /= d/2;
            if (t < 1) return c/2 * Math.pow( 2, 10 * (t - 1) ) + b;
            t--;
            return c/2 * ( -Math.pow( 2, -10 * t) + 2 ) + b;
        },
        easeInCirc: function(t, b, c, d){
            t /= d;
	        return -c * (Math.sqrt(1 - t*t) - 1) + b;
        },
        easeOutCirc: function(t, b, c, d){
            t /= d;
            t--;
            return c * Math.sqrt(1 - t*t) + b;
        },
        easeInOutCirc: function(t, b, c, d){
            t /= d/2;
            if (t < 1) return -c/2 * (Math.sqrt(1 - t*t) - 1) + b;
            t -= 2;
            return c/2 * (Math.sqrt(1 - t*t) + 1) + b;
        },
        easeInBack: function(t, b, c, d){
            var s = 1.70158;
	        return c*(t/=d)*t*((s+1)*t - s) + b;
        },
        easeOutBack: function(t, b, c, d){
            var s = 1.70158;
	        return c*((t=t/d-1)*t*((s+1)*t + s) + 1) + b;
        },
        easeInOutBack: function(t, b, c, d){
            var s = 1.70158; 
	        if ((t/=d/2) < 1) return c/2*(t*t*(((s*=(1.525))+1)*t - s)) + b;
	        return c/2*((t-=2)*t*(((s*=(1.525))+1)*t + s) + 2) + b;
        },
        easeOutBounce: function(t, b, c, d){
            if ((t/=d) < (1/2.75)) {
                return c*(7.5625*t*t) + b;
              } else if (t < (2/2.75)) {
                return c*(7.5625*(t-=(1.5/2.75))*t + .75) + b;
              } else if (t < (2.5/2.75)) {
                return c*(7.5625*(t-=(2.25/2.75))*t + .9375) + b;
              } else {
                return c*(7.5625*(t-=(2.625/2.75))*t + .984375) + b;
              }
        },
        easeInBounce: function(t, b, c, d){
            if ((t/=d) < (1/2.75)) {
		        return c*(7.5625*t*t) + b;
	        } else if (t < (2/2.75)) {
                return c*(7.5625*(t-=(1.5/2.75))*t + 0.75) + b;
            } else if (t < (2.5/2.75)) {
                return c*(7.5625*(t-=(2.25/2.75))*t + 0.9375) + b;
            } else {
                return c*(7.5625*(t-=(2.625/2.75))*t + .984375) + b;
            }
        },
        easeInOutBounce: function(t, b, c, d){
            if (t < d/2) return easeInBounce (t*2, 0, c, d) * 0.5 + b;
	        else return easeOutBounce (t*2-d, 0, c, d) * 0.5 + c*0.5 + b;
        },
        easeInElastic: function(t, b, c, d){
            var a=c;
            var p=d*0.3;
            var s=p/4;
            if (t==0) return b;  if ((t/=d)==1) return b+c;
	        return -(a*Math.pow(2,10*(t-=1)) * Math.sin( (t*d-s)*(2*Math.PI)/p )) + b;
        },
        easeOutElastic: function(t, b, c, d){
            var a=c;
            var p=d*0.3;
            var s=p/4;
            if (t==0) return b;  if ((t/=d)==1) return b+c;
            return (a*Math.pow(2,-10*t) * Math.sin( (t*d-s)*(2*Math.PI)/p ) + c + b);
        },
        easeInOutElastic: function(t, b, c, d){
           var a=c;
            var p=d*(0.3*1.5);
            var s=p/4;
            if (t==0) return b;  if ((t/=d/2)==2) return b+c;
            if (t < 1) return -0.5*(a*Math.pow(2,10*(t-=1)) * Math.sin( (t*d-s)*(2*Math.PI)/p )) + b;
            return a*Math.pow(2,-10*(t-=1)) * Math.sin( (t*d-s)*(2*Math.PI)/p )*0.5 + c + b;
        }
    };


resourceManager.registerController("animationController", animationController.create);
})();